export default "__VITE_ASSET__69892944__"